'use strict';

export const itemPerPage: number = 10;
export const paginationMaxSize: number = 5;
export const pageSize: number = 10; 
export const itemPerPageNumList:any = [10,20,30,50,100,200,300,500,1000];
export const demo: boolean = false; 